const METRICS_PAYLOAD_VERSION = '1';

export { METRICS_PAYLOAD_VERSION };
